<div class="top-action">
  Already have an account?
  <a class="link" (click)="!loading() && showSignIn()">Sign In</a>
</div>
<div class="form" [class.loading]="loading()">
  @if (loading()) {
    <div class="loading-overlay">
      <app-loading-spinner/>
    </div>
  }
  <div class="title">
    <p>Sign in</p>
  </div>
  <div class="horizontal-separator"></div>
  <form [formGroup]="form()">
    <div class="f-row">
      <div class="f-group">
        <label>Email*</label>
        <input
          formControlName="email"
          placeholder="Enter your email address to receive a magic link"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('email').touched &&
            form().get('email').invalid
          "
        />
      </div>
    </div>
  </form>
  @if (error()) {
    <div class="message error">
      {{ error() }}
    </div>
  }
  @if (showInstructions()) {
    <div class="message">
      We've sent an email to {{ form().get('email').value }} with a link to log you in. The link expires shortly, so please click on it soon.
    </div>
  }
</div>
